import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import _objectSpread from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import { transformResponse } from './util';
/**
 * 普通request
 * @param {*} servicePath 服务路径
 * @param {*} api 接口名称
 * @param {*} params 请求体参数
 * @param {*} options request参数
 */

function request(servicePath, api, params) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return new Promise(function (resolve, reject) {
    var _options$method;

    var isPost = ((_options$method = options.method) === null || _options$method === void 0 ? void 0 : _options$method.toLowerCase()) === 'post';
    var body = isPost ? {
      data: params
    } : {
      params: {
        rpc_data: params
      }
    };
    var baseUrl = options.useCdn ? '//vipcdn.video.qq.com/rpc/' : '//vip.video.qq.com/rpc/';
    axios.request(_objectSpread(_objectSpread({
      method: isPost ? 'post' : 'get',
      url: "/".concat(servicePath, "/").concat(api),
      baseURL: options.baseURL || baseUrl,
      withCredentials: !!options.withCredentials
    }, body), {}, {
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      validateStatus: function validateStatus(status) {
        return status === 200;
      },
      transformResponse: transformResponse
    })).then(function (_ref) {
      var data = _ref.data;
      // 对请求做处理
      resolve(data);
    }, function (err) {
      reject(err);
    });
  });
}

export default request;